export const TextBlock = ({ data }: any) => {
    return (
        <div
            className="py-8 px-4 container mx-auto"
            style={{
                textAlign: data.textAlign || 'left',
                color: data.color,
                backgroundColor: data.backgroundColor
            }}
        >
            <div dangerouslySetInnerHTML={{ __html: data.content }} />
        </div>
    );
};
